export const navData = [

    {
        id: 1,
        // icon: <TravelExploreIcon />,
        text: "Explore",
        link: "/",
    },
    // {
    //     id: 2,
    //     // icon: <BarChartIcon />,
    //     text: "Statistics",
    //     link: "/statistics",
    // },
    // {
    //     id: 3,
    //     // icon: <SettingsIcon />,
    //     text: "People",
    //     link: "/people",
    // },
    {
        id: 4,
        text: "Sandpit",
        link: "/#/sandpit",
    },
];
